export default __webpack_public_path__ + "static/media/Img4@2x.6591648c.jpg";